import { playSound } from './audio';
export { initializeSounds, playSound, preloadSounds } from './audio';

export const getRandomMultiplayerRoll = () => Math.floor(Math.random() * 100);

export const getWinner = (playerNamesState) => {
  const firstPlayer = playerNamesState[0];
  let maxNumber = -1;
  let winningPlayer = firstPlayer.name;
  let winningID = null;
  let tieWinners = [];

  for (let i = 0; i < playerNamesState.length; i++) {
    const currentPlayer = playerNamesState[i];
    if (currentPlayer.rolls[currentPlayer.rolls.length - 1] > maxNumber) {
      maxNumber = currentPlayer.rolls[currentPlayer.rolls.length - 1];
      winningPlayer = currentPlayer.name;
      winningID = currentPlayer.id;
      tieWinners = [];
      tieWinners.push(currentPlayer);
    } else if (
      currentPlayer.rolls[currentPlayer.rolls.length - 1] === maxNumber
    ) {
      winningID = null;
      tieWinners.push(currentPlayer);
    }
  }

  return [winningPlayer, maxNumber, winningID, tieWinners];
};

export const getTiebreakerWinner = (tiebreakerState) => {
  const firstPlayer = tiebreakerState[0];
  let maxNumber = -1;
  let winningPlayer = firstPlayer.name;
  let winningID = firstPlayer.id;
  let tieWinners = [];

  for (let i = 0; i < tiebreakerState.length; i++) {
    const currentPlayer = tiebreakerState[i];
    if (currentPlayer.rolls[currentPlayer.rolls.length - 1] > maxNumber) {
      maxNumber = currentPlayer.rolls[currentPlayer.rolls.length - 1];
      winningPlayer = currentPlayer.name;
      winningID = currentPlayer.id;
      tieWinners = [];
      tieWinners.push(currentPlayer);
    } else if (
      currentPlayer.rolls[currentPlayer.rolls.length - 1] === maxNumber
    ) {
      winningID = null;
      tieWinners.push(currentPlayer);
    }
  }

  return [winningPlayer, maxNumber, winningID, tieWinners];
};

export const HomeSVG = () => {
  return (
    <svg
      className="HomeSVG"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 340 340"
      aria-hidden="true"
      focusable="false"
    >
      <g className="homeReactor__calibration">
        {Array.from({ length: 48 }, (_, index) => (
          <path
            key={index}
            d={index % 4 === 0 ? 'M170 8V21' : 'M170 11V16'}
            transform={`rotate(${index * 7.5} 170 170)`}
          />
        ))}
      </g>
      <circle
        className="circleHome"
        cx="170"
        cy="170"
        r="160"
        stroke="#E2007C"
      />
      <circle
        className="circleHome"
        cx="170"
        cy="170"
        r="135"
        stroke="#404041"
      />
      <circle
        className="circleHome"
        cx="170"
        cy="170"
        r="110"
        stroke="#E2007C"
      />
      <circle
        className="circleHome"
        cx="170"
        cy="170"
        r="85"
        stroke="#404041"
      />
      <g className="homeReactor__cage">
        <path d="M170 48 276 109 276 231 170 292 64 231 64 109Z" />
        <path d="M170 70 257 120 257 220 170 270 83 220 83 120Z" />
      </g>
      <g className="homeReactor__orbit homeReactor__orbit--one">
        <ellipse cx="170" cy="170" rx="140" ry="53" />
        <circle cx="310" cy="170" r="4" />
      </g>
      <g className="homeReactor__orbit homeReactor__orbit--two">
        <ellipse cx="170" cy="170" rx="140" ry="53" />
        <circle cx="30" cy="170" r="4" />
      </g>
      <g className="homeReactor__core">
        <circle cx="170" cy="170" r="51" />
        <path
          className="homeReactor__diamond"
          d="M170 107 233 170 170 233 107 170Z"
        />
        <path
          className="homeReactor__slash"
          d="M160 138 143 202 M196 138 179 202"
        />
      </g>
      <g className="homeReactor__satellites">
        <circle cx="170" cy="35" r="5" />
        <circle cx="170" cy="305" r="5" />
        <path d="M35 164V176 M29 170H41 M299 170H311 M305 164V176" />
      </g>
    </svg>
  );
};

export const PreRollSVG = ({ handleClick }) => {
  return (
    <svg
      className="PreRollSVG"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 340 340"
      onClick={handleClick}
    >
      <circle
        className="circleRoll"
        cx="170"
        cy="170"
        r="160"
        stroke="#E2007C"
      />
      <circle
        className="circleRoll"
        cx="170"
        cy="170"
        r="135"
        stroke="#404041"
      />
      <circle
        className="circleRoll"
        cx="170"
        cy="170"
        r="110"
        stroke="#E2007C"
      />
      <circle
        className="circleRoll"
        cx="170"
        cy="170"
        r="85"
        stroke="#404041"
      />
    </svg>
  );
};

export const handleHomeClick = () => {
  playSound('/sounds/futuristic-zoom.mp3');
};
